export default function hiddenList(selector, btnTextHidden, btnTextShow) {
    const hiddenItems = document.querySelectorAll(`${selector} .hidden_item`);
    const showAllButton = document.querySelector(`${selector} .show_all`);
    const btnText = showAllButton.querySelector("span");

    let isHidden = true;

    showAllButton.addEventListener("click", () => {
        btnText.textContent = isHidden ? btnTextShow : btnTextHidden;
        showAllButton.classList.toggle("active");
        hiddenItems.forEach(item => item.classList.toggle("hidden"));
        isHidden = !isHidden;
    });
}
